import { render, staticRenderFns } from "./bubble.md?vue&type=template&id=534841a7&"
import script from "./bubble.md?vue&type=script&lang=js&"
export * from "./bubble.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534841a7')) {
      api.createRecord('534841a7', component.options)
    } else {
      api.reload('534841a7', component.options)
    }
    module.hot.accept("./bubble.md?vue&type=template&id=534841a7&", function () {
      api.rerender('534841a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/scatter/bubble.md"
export default component.exports